import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    loading: _ctx.load,
    filter: true,
    filterMode: "lenient",
    value: _ctx.menuElements,
    expandedKeys: _ctx.expandedKeys,
    selectionMode: "single",
    selectionKeys: _ctx.selectedMenuNode,
    "onUpdate:selectionKeys": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedMenuNode = $event)),
    metaKeySelection: false,
    onNodeSelect: _ctx.onNodeSelect,
    onNodeUnselect: _ctx.onNodeUnselect,
    "data-test": "menu-nodes-tree",
    class: "kn-tree kn-flex toolbar-height",
    scrollHeight: "flex"
  }, {
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx((slotProps) => [
      _createVNode("div", {
        class: "p-d-flex p-flex-row p-ai-center",
        onMouseover: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = true),
        onMouseleave: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = false),
        "data-test": 'menu-nodes-tree-item-' + slotProps.node.menuId
      }, [
        _createVNode("span", null, _toDisplayString(slotProps.node.name), 1),
        _withDirectives(_createVNode("div", _hoisted_1, [
          (slotProps.node.parentId != null)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-sort-alt",
                class: "p-button-link p-button-sm p-p-0",
                onClick: ($event: any) => (_ctx.changeWithFather(slotProps.node.menuId)),
                "data-test": 'change-with-father-button-' + slotProps.node.menuId
              }, null, 8, ["onClick", "data-test"]))
            : _createCommentVNode("", true),
          (_ctx.canBeMovedUp(slotProps.node))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                icon: "pi pi-arrow-up",
                class: "p-button-link p-button-sm p-p-0",
                onClick: ($event: any) => (_ctx.moveUp(slotProps.node.menuId)),
                "data-test": 'move-up-button-' + slotProps.node.menuId
              }, null, 8, ["onClick", "data-test"]))
            : _createCommentVNode("", true),
          (_ctx.canBeMovedDown(slotProps.node))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                icon: "pi pi-arrow-down",
                class: "p-button-link p-button-sm p-p-0",
                onClick: ($event: any) => (_ctx.moveDown(slotProps.node.menuId)),
                "data-test": 'move-down-button-' + slotProps.node.menuId
              }, null, 8, ["onClick", "data-test"]))
            : _createCommentVNode("", true),
          (_ctx.canBeDeleted(slotProps.node))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                icon: "far fa-trash-alt",
                class: "p-button-link p-button-sm p-p-0",
                onClick: ($event: any) => (_ctx.deleteMenuNode(slotProps.node.menuId)),
                "data-test": 'delete-button-' + slotProps.node.menuId
              }, null, 8, ["onClick", "data-test"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.buttonsVisible[slotProps.node.id]]
        ])
      ], 40, ["onMouseover", "onMouseleave", "data-test"])
    ]),
    _: 1
  }, 8, ["loading", "value", "expandedKeys", "selectionKeys", "onNodeSelect", "onNodeUnselect"]))
}